<template>
  <div>
    <Breadcrumbs title="Dashboard" />
    <!-- Container-fluid starts-->
    <div class="container-fluid animated fadeIn" v-if="accounts && inflowOutflow">
        <div class="news">
            <div class="row">
                <div class="col-xl-4 col-lg-12">
                    <div id="profile" class="card o-hidden profile-greeting">
                        <div class="card-body">
                            <!-- <div class="media">
                                <div class="badge-groups w-100" >
                                    <div class="badge f-12" style="background-color: rgba(0, 0, 0, 0.1);">
                                        <i class="fa fa-calendar"></i>
                                        &nbsp;{{currentDate | moment}}
                                    </div>
                                    <div class="badge f-12" style="background-color: rgba(0, 0, 0, 0.1);">
                                        <i class="me-1 fa fa-clock-o"></i><span> {{ time | momentWith12Hours }}</span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="greeting-user text-center">
                                <div class="profile-vector mb-2">
                                  <img class="rounded-circle" width="110" height="110" :src="imageBase64" alt="" />
                                  <!-- <img class="rounded-circle" width="110" height="110" v-else :src="userImage" alt="" /> -->
                                </div>
                                <h6 class="mb-2 mt-1 text-white">
                                    <span style="font-size:15px; font-weight:400">{{ greeting }}</span>
                                    <span style="font-weight: 500">, {{userName}}</span>
                                    <span class="right-circle">
                                        <i class="fa fa-check-circle f-14 middle"></i>
                                    </span>
                                </h6>
                                <h6  class="mt-2 text-white" style="font-weight:400; font-size: 14px;cursor: pointer">
                                    Referral code: <span :class="isCopycode ? 'text-success' : 'text-white'"
                                    v-clipboard:copy="accounts.customerDetails.referralCode"
                                    v-clipboard:success="onCopyCode">{{ accounts.customerDetails.referralCode }} <i class="fa fa-copy"></i></span>
                                </h6>
                                <span class="mt-3 text-white">
                                    Welcome to TAJBank Retail Banking Platform
                                </span>
                                <div class="mt-2" style="background-color: rgba(0, 0, 0, 0.1);">
                                    <span class="p-2 text-white" style="font-weight:500; font-size: 12px;">
                                        Last Login:{{ lastLoginDate | momentWithSeconds}}</span>
                                </div>
                                <div class="whatsnew-btn" style="padding-bottom:0">
                                </div>
                                <!-- <div class="left-icon" title="Notifications">
                                <i class="fa fa-bell"> </i>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 cardGreeting">
                    <div class="row">
                        <div class="col-12">
                            <div id="account-details" class="card" style="margin-bottom:0px;">
                                <div class="card-body p-0 accountCard">
                                  <div class="bd-example">
                                      <div id="carouselAccountCaptions" class="carousel slide" data-ride="carousel" data-interval="false">
                                          <div class="carousel-inner">
                                              <div class="mt-4 mb-3 carousel-item active" style="padding-left:15%;padding-right:15%">
                                                  <div class="row">
                                                      <div class="col-md-6 text-lg-start text-md-left text-sm-center text-center">
                                                          <img src="@/assets/TAJimages/dashboard/accWalletImg.png" style="height:75px;width:75px" />
                                                      </div>
                                                      <div class="col-md-6 d-flex justify-content-end fit-mobile align-items-start">
                                                        <div>
                                                          <router-link to="/settings/limit-upgrade" class="text-danger border border-danger rounded py-1 px-3" style="letter-spacing:0px">Upgrade Limit!</router-link>
                                                          <p class="pt-3 font-weight-bold">Daily Limit: <span class="text-danger">₦{{new Intl.NumberFormat('en-NG', {}).format(limitOne ? limitOne.availableTransactionLimit : 0)}}</span></p>
                                                        </div>
                                                        <!-- <button type="button" class="btn btn-outline-danger">Upgrade Limit</button> -->
                                                      </div>
                                                  </div>
                                                  <div class="row mt-3">
                                                      <div class="col-md-8">
                                                          <div class="text-lg-start text-md-left text-sm-center text-center">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">{{accounts.accounts[0].productName}} <span class="ml-2 badge badge-pill badge-custom">Tier {{accounts.accounts[0].kycLevel}} {{accounts.accounts[0].accountType}}</span></span>
                                                              </div>
                                                              <div style="margin-top:10px;" >
                                                                  <div class="mt-0">{{userAccounts[0].accountName}}</div>
                                                                  <div class="mt-0 animated fadeIn account-number-show" v-if="showAccountNumber">
                                                                      {{userAccounts[0].accountNumber}} <i class="text-danger fa fa-eye-slash" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                                  <div class="mt-0 animated fadeIn account-number-hide" v-show="!showAccountNumber">
                                                                      XXXXXXXXXX <i class="text-danger fa fa-eye" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <div class="text-lg-left text-xl-start text-md-start text-sm-center text-center mt-lg-0 mt-md-0 mt-sm-3 mt-3">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">TOTAL BALANCE</span>
                                                              </div>
                                                              <div style="margin-top:10px;">
                                                                  <div class="mt-0 balance-show animated fadeIn" v-if="showBalance">
                                                                      <h4 class="text-md-left text-sm-center account-balance">₦{{new Intl.NumberFormat('en-NG', {}).format(userAccounts[0].availableBalance)}} <i class="fs-6 text-danger fa fa-eye-slash" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                                  <div class="mt-0 balance-hide animated fadeIn" v-show="!showBalance">
                                                                      <h4 class="text-lg-left account-balance text-center">XXXXXX <i class="text-danger fa fa-eye" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="mt-4 mb-3 carousel-item" v-if="userAccounts.length > 1" style="padding-left:15%;padding-right:15%">
                                                  <div class="row">
                                                      <div class="col-md-6 text-lg-start text-md-left text-sm-center text-center">
                                                          <img src="@/assets/TAJimages/dashboard/accWalletImg.png" style="height:75px;width:75px" />
                                                      </div>
                                                      <div class="col-md-6 d-flex justify-content-end fit-mobile align-items-start">
                                                        <div>
                                                          <router-link to="/settings/limit-upgrade" class="text-danger border border-danger rounded py-1 px-3" style="letter-spacing:0px">Upgrade Limit!</router-link>
                                                          <p class="pt-3 font-weight-bold">Daily Limit: <span class="text-danger">₦{{new Intl.NumberFormat('en-NG', {}).format(limitTwo ? limitTwo.availableTransactionLimit : 0)}}</span></p>
                                                        </div>
                                                        <!-- <button type="button" class="btn btn-outline-danger">Upgrade Limit</button> -->
                                                      </div>
                                                  </div>
                                                  <div class="row mt-3">
                                                      <div class="col-md-8">
                                                          <div class="text-lg-start text-md-left text-sm-center text-center">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">{{accounts.accounts[0].productName}} <span class="ml-2 badge badge-pill badge-custom">Tier {{accounts.accounts[1].kycLevel}} {{accounts.accounts[1].accountType}}</span></span>
                                                              </div>
                                                              <div style="margin-top:10px;" >
                                                                  <div class="mt-0">{{userAccounts[1].accountName}}</div>
                                                                  <div class="mt-0 animated fadeIn account-number-show" v-if="showAccountNumber">
                                                                      {{userAccounts[1].accountNumber}} <i class="text-danger fa fa-eye-slash" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                                  <div class="mt-0 animated fadeIn account-number-hide" v-show="!showAccountNumber">
                                                                      XXXXXXXXXX <i class="text-danger fa fa-eye" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <div class="text-lg-left text-xl-start text-md-start text-sm-center text-center mt-lg-0 mt-md-0 mt-sm-3 mt-3">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">TOTAL BALANCE</span>
                                                              </div>
                                                              <div style="margin-top:10px;">
                                                                  <div class="mt-0 balance-show animated fadeIn" v-if="showBalance">
                                                                      <h4 class="text-md-left text-sm-center account-balance">₦{{new Intl.NumberFormat('en-NG', {}).format(userAccounts[1].availableBalance)}} <i class="fs-6 text-danger fa fa-eye-slash" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                                  <div class="mt-0 balance-hide animated fadeIn" v-show="!showBalance">
                                                                      <h4 class="text-lg-left account-balance text-center">XXXXXX <i class="text-danger fa fa-eye" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="mt-4 mb-3 carousel-item" v-if="userAccounts.length > 2" style="padding-left:15%;padding-right:15%">
                                                  <div class="row">
                                                      <div class="col-md-6 text-lg-start text-md-left text-sm-center text-center">
                                                          <img src="@/assets/TAJimages/dashboard/accWalletImg.png" style="height:75px;width:75px" />
                                                      </div>
                                                      <div class="col-md-6 d-flex justify-content-end fit-mobile align-items-start">
                                                        <div>
                                                          <router-link to="/settings/limit-upgrade" class="text-danger border border-danger rounded py-1 px-3" style="letter-spacing:0px">Upgrade Limit!</router-link>
                                                          <p class="pt-3 font-weight-bold">Daily Limit: <span class="text-danger">₦{{new Intl.NumberFormat('en-NG', {}).format(limitThree ? limitThree.availableTransactionLimit : 0)}}</span></p>
                                                        </div>
                                                        <!-- <button type="button" class="btn btn-outline-danger">Upgrade Limit</button> -->
                                                      </div>
                                                  </div>
                                                  <div class="row mt-3">
                                                      <div class="col-md-8">
                                                          <div class="text-lg-start text-md-left text-sm-center text-center">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">{{accounts.accounts[0].productName}} <span class="ml-2 badge badge-pill badge-custom">Tier {{accounts.accounts[2].kycLevel}} {{accounts.accounts[2].accountType}}</span></span>
                                                              </div>
                                                              <div style="margin-top:10px;" >
                                                                  <div class="mt-0">{{userAccounts[2].accountName}}</div>
                                                                  <div class="mt-0 animated fadeIn account-number-show" v-if="showAccountNumber">
                                                                      {{userAccounts[2].accountNumber}} <i class="text-danger fa fa-eye-slash" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                                  <div class="mt-0 animated fadeIn account-number-hide" v-show="!showAccountNumber">
                                                                      XXXXXXXXXX <i class="text-danger fa fa-eye" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <div class="text-lg-left text-xl-start text-md-start text-sm-center text-center mt-lg-0 mt-md-0 mt-sm-3 mt-3">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">TOTAL BALANCE</span>
                                                              </div>
                                                              <div style="margin-top:10px;">
                                                                  <div class="mt-0 balance-show animated fadeIn" v-if="showBalance">
                                                                      <h4 class="text-md-left text-sm-center account-balance">₦{{new Intl.NumberFormat('en-NG', {}).format(userAccounts[2].availableBalance)}} <i class="fs-6 text-danger fa fa-eye-slash" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                                  <div class="mt-0 balance-hide animated fadeIn" v-show="!showBalance">
                                                                      <h4 class="text-lg-left account-balance text-center">XXXXXX <i class="text-danger fa fa-eye" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="mt-4 mb-3 carousel-item" v-if="userAccounts.length > 3" style="padding-left:15%;padding-right:15%">
                                                  <div class="row">
                                                      <div class="col-md-6 text-lg-start text-md-left text-sm-center text-center">
                                                          <img src="@/assets/TAJimages/dashboard/accWalletImg.png" style="height:75px;width:75px" />
                                                      </div>
                                                      <div class="col-md-6 d-flex justify-content-end fit-mobile align-items-start">
                                                        <div>
                                                          <router-link to="/settings/limit-upgrade" class="text-danger border border-danger rounded py-1 px-3" style="letter-spacing:0px">Upgrade Limit!</router-link>
                                                          <p class="pt-3 font-weight-bold">Daily Limit: <span class="text-danger">₦{{new Intl.NumberFormat('en-NG', {}).format(limitFour ? limitFour.availableTransactionLimit : 0)}}</span></p>
                                                        </div>
                                                        <!-- <button type="button" class="btn btn-outline-danger">Upgrade Limit</button> -->
                                                      </div>
                                                  </div>
                                                  <div class="row mt-3">
                                                      <div class="col-md-8">
                                                          <div class="text-lg-start text-md-left text-sm-center text-center">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">{{accounts.accounts[0].productName}} <span class="ml-2 badge badge-pill badge-custom">Tier {{accounts.accounts[3].kycLevel}} {{accounts.accounts[3].accountType}}</span></span>
                                                              </div>
                                                              <div style="margin-top:10px;" >
                                                                  <div class="mt-0">{{userAccounts[3].accountName}}</div>
                                                                  <div class="mt-0 animated fadeIn account-number-show" v-if="showAccountNumber">
                                                                      {{userAccounts[3].accountNumber}} <i class="text-danger fa fa-eye-slash" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                                  <div class="mt-0 animated fadeIn account-number-hide" v-show="!showAccountNumber">
                                                                      XXXXXXXXXX <i class="text-danger fa fa-eye" @click="showAccountNumber = !showAccountNumber"></i>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div class="col-md-4">
                                                          <div class="text-lg-left text-xl-start text-md-start text-sm-center text-center mt-lg-0 mt-md-0 mt-sm-3 mt-3">
                                                              <div class="profile-vector" style="margin-bottom:0px">
                                                                  <span style="font-size:14px">TOTAL BALANCE</span>
                                                              </div>
                                                              <div style="margin-top:10px;">
                                                                  <div class="mt-0 balance-show animated fadeIn" v-if="showBalance">
                                                                      <h4 class="text-md-left text-sm-center account-balance">₦{{new Intl.NumberFormat('en-NG', {}).format(userAccounts[3].availableBalance)}} <i class="fs-6 text-danger fa fa-eye-slash" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                                  <div class="mt-0 balance-hide animated fadeIn" v-show="!showBalance">
                                                                      <h4 class="text-lg-left account-balance text-center">XXXXXX <i class="text-danger fa fa-eye" @click="showBalance = !showBalance"></i></h4>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <a class="carousel-control-prev" href="#carouselAccountCaptions" role="button" data-slide="prev">
                                              <img src="@/assets/fonts/left-arrow-in-circle-outline.svg" width="35px" height="35px" alt="--" aria-hidden="true" />
                                          </a>
                                          <a class="carousel-control-next" href="#carouselAccountCaptions" role="button" data-slide="next">
                                              <img src="@/assets/fonts/right-arrow.svg" width="35px" height="35px" alt="--" aria-hidden="true" />
                                          </a>
                                      </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                          <div class="col-xl-3 col-6">
                            <router-link to="/transfers/own-account-transfer">
                              <div class="card card-wrapper p-3 text-center">
                                <div class="icon-wrapper fund-transfer shadow-sm">
                                  <feather class="primary-color icon-feather" type="send"></feather>
                                </div>
                                <p class="text-icon">Fund Transfer</p>
                              </div>
                             </router-link>
                          </div>
                        <div class="col-xl-3 col-6">
                            <router-link to="/bills/cablePayment">
                              <div class="card card-wrapper p-3 text-center">
                                <div class="icon-wrapper pay-bills shadow-sm">
                                  <feather class="primary-color icon-feather" type="file-text"></feather>
                                </div>
                                <p class="text-icon">Pay Bills</p>
                              </div>
                            </router-link>
                        </div>
                        <div class="col-xl-3 col-6">
                          <router-link to="/bills/airtime-purchase">
                            <div class="card card-wrapper p-3 text-center">
                              <div class="icon-wrapper airtime-data shadow-sm">
                                <feather class="primary-color icon-feather" type="phone"></feather>
                              </div>
                              <p class="text-icon">Airtime & Data</p>
                            </div>
                          </router-link>
                        </div>
                        <div class="col-xl-3 col-6">
                          <router-link to="/account/fund-account">
                            <div class="card card-wrapper p-3 text-center">
                              <div class="icon-wrapper quick-balance shadow-sm">
                                <feather class="primary-color icon-feather" type="smartphone"></feather>
                              </div>
                              <p class="text-icon">Fund Account</p>
                            </div>
                          </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" style="margin-bottom:3%;">
            <div class="col-md-7">
                <div class="card" style="margin-bottom:0px;">
                    <div class="card-body p-0">
                        <div class="row p-4">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6>Inflows/Outflows</h6>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="d-flex justify-content-end flex-wrap">
                                        <div>
                                          <select id="TransactionVolumeAccountNumber" v-model="accountNumber" name="TransactionVolumeAccountNumber" class="form-control pull-right" style="margin-right:7px;">
                                            <option value="" disabled>Account Number</option>
                                            <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}}</option>
                                          </select>
                                        </div>
                                        <div>
                                          <select @change="selectWeek" id="InflowFilter" class="form-control pull-right" style="width:100%;">
                                            <option :disabled="accountNumber !== ''">Select Week</option>
                                            <option value="thisWeek" :disabled="accountNumber === ''">This Week</option>
                                            <option value="lastWeek" :disabled="accountNumber === ''">Last Week</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div id="loader-polar" v-if="loader" class='loader-box text-center py-5'><div style="color:#fff" class='loader-15'></div></div>
                                <div class="chart-container mt-3" style="position: relative; height:100%; width:100%">
                                      <Bar :styles="myStyles" v-if="loaded" :chartdata="chartData" :options="options"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="card" style="margin-bottom:0px;">
                    <div class="card-body p-0">
                        <div class="row p-4">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6>Outflows</h6>
                                    </div>
                                    <div class="col-md-8">
                                      <div class="d-flex justify-content-end flex-wrap">
                                        <div>
                                          <select id="TransactionVolumeAccountNumber" v-model="volumeAccountNumber" name="TransactionVolumeAccountNumber" class="form-control pull-right" style="margin-right:7px;">
                                            <option value="" disabled>Account Number</option>
                                            <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}}</option>
                                          </select>
                                        </div>
                                        <div>
                                          <select @change="selectVolumeWeek" id="InflowFilter" class="form-control pull-right" style="width:100%;">
                                            <option :disabled="volumeAccountNumber !== ''">Select Week</option>
                                            <option value="thisWeek" :disabled="volumeAccountNumber === ''">This Week</option>
                                            <option value="lastWeek" :disabled="volumeAccountNumber === ''">Last Week</option>
                                          </select>
                                          
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div id="loader-polar" v-if="newloader" class='loader-box text-center py-5'><div style="color:#fff" class='loader-15'></div></div>
                                <div class="chart-container-1 mt-3" style="position: relative; height:100%; width:100%">
                                    <polar :styles="myStyles" v-if="newloaded" :chartdata="data" :options="options"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 news box-col-12">
                <div class="card lifestyle-card-wrapper">
                    <div class="card-header">
                        <div class="header-top">
                          <h5 class="m-0">Lifestyle</h5>
                          <router-link to="/services/lifestyle" class="pull-right btn btn-primary text-white">See More <i class="fa fa-angle-right"></i></router-link>
                        </div>
                    </div>
                    <!-- card body -->
                    <div class="card-body">
                      <div class="row">
                          <div class="col-md-3 lifestyle-card">
                            <router-link to="/lifestyle/flight">
                              <img src="@/assets/TAJimages/travel.png" class="img-fluid">
                              <h4 class="lifestyle-text">Travel</h4>
                            </router-link>
                          </div>
                        <div class="col-md-3 lifestyle-card">
                          <router-link to="/lifestyle/hotel">
                              <img src="@/assets/TAJimages/hotels/hotel-bg.png" class="img-fluid">
                              <h4 class="lifestyle-text">Hotels</h4>
                          </router-link>
                        </div>
                        <div class="col-md-3 lifestyle-card">
                          <img src="@/assets/TAJimages/events.png" class="img-fluid">
                          <h4 class="lifestyle-text">Events</h4>
                        </div>
                        <div class="col-md-3 lifestyle-card">
                          <img src="@/assets/TAJimages/tajmall.png" class="img-fluid">
                          <h4 class="lifestyle-text">Taj Mall</h4>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
    <div v-else class="loader-12"></div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  import Bar from './chart/bar';
  import polar from './chart/polar';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
      Bar,
      polar
    },
    filters: {
      moment: function (date) {
        return moment(date).format('dddd, MMMM DD, YYYY');
      },
      // moment with seconds
      momentWithSeconds: function (date) {
        return moment(date).format('dddd, MMMM DD, YYYY hh:mm:ss A');
      },
      // moment with 12 hours format
      momentWith12Hours: function (date) {
        return moment(date, ['HH.mm']).format('hh:mm a');
      },
    },
    data:() => ({
      greeting: null,
      time: null,
      currentDate: new Date(),
      accountNumber: '',
      volumeAccountNumber: '',
      showAccountNumber: false,
      showBalance: false,
      cummulativeInflow: [],
      cummulativeOutflow: [],
      loaded: false,
      loader: false,
      newloaded: false,
      newloader: false,
      isCopycode: false,
      // lastLogin: localStorage.getItem('lastLogin'),
      userImage: require('@/assets/TAJimages/user/user.png'),
      data: {
        labels: ['Airtime Payment', 'Bills Payment', 'Interbank Transfer', 'Local Transfer'],
        datasets: [{
          data: [],
          labels: 'Outflows',
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
          ],
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
          },
        }
      },
      chartData: {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [
          {
            label: 'Inflows',
            data: [],
            backgroundColor: [
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
              'rgb(161, 255, 146)',
            ],
          },
          {
            label: 'Outflows',
            data: [],
            backgroundColor: [
              '#e41f13',
              '#e41f13',
              '#e41f13',
              '#e41f13',
              '#e41f13',
              '#e41f13',
              '#e41f13',
            ],
          }]
      },
      activeIndex: 0,
      limitOne: 0,
      limitTwo: 0,
      limitThree: 0,
      limitFour: 0,
      changePin: JSON.parse(localStorage.getItem('forceChangePin')),
    }),
    computed: {
      ...mapState({
        accounts: (state) => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: (state) => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        // eslint-disable-next-line no-confusing-arrow
        inflowOutflow: (state) => state.dashboard ? state.dashboard.inflowOutflow : null,
        auth: (state) => state.authentication.user,
        profilePicture: state => state.dashboard.profilePicture,
        transactionVolume: state => state.dashboard.transactionVolume,
        lastLoginDate: state => state.authentication.lastLogin,
      }),
      imageBase64() {
        return this.profilePicture ? `data:image/png;base64,${this.profilePicture}` : this.userImage;
      },
      userName() {
        return this.accounts ? this.accounts.customerDetails.firstName : null;
      },
      accountUsername() {
        return this.accounts ? this.accounts.customerDetails.userName : null;
      },
      userAccountNumber() {
        return this.accounts ? this.accounts.accounts[0].accountNumber : null;
      },
      kycLevel() {
        return this.accounts ? this.accounts.accounts[0].kycLevel : 0;
      },
      productName() {
        return this.accounts ? this.accounts.accounts[0].productName : 'N/A';
      },
      userEmail() {
        return this.accounts ? this.accounts.customerDetails.email : '';
      },
      myStyles () {
        return {
          height: `300px`,
          position: 'relative'
        };
      },
      // bind active class to carousel item when next or prev button is clicked
      activeClass() {
        return {
          active: this.activeIndex === 0,
        };
      },
    },
    mounted() {
      this.$store.dispatch('dashboard/getDashboardData').then(async (response) => {
        if(response.status === 200) {
          this.fecthData();
          this.fetchTransactionVolume();
          const data = {
            userName: this.accountUsername
          };
          this.$store.dispatch('setLastLogin', data);
          if(this.kycLevel <= 2 && !this.changePin) {
            this.$swal({
              text:`Kindly Upgrade Your Account`,
              showCancelButton: true,
              confirmButtonText: 'Proceed',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn btn-primary',
              confirmButtonClass: 'btn btn-success mr-2',
              buttonsStyling: false,
              type:'info'
            }).then((result) => {
              if(result.value) {
                this.$router.push({ name: 'account-upgrade' });
              }
            });
          }
          const res = await this.getAvailableLimit(this.userAccounts[0].accountNumber)
          this.limitOne = this.decryptResponse(res.data)
          const res2 = await this.getAvailableLimit(this.userAccounts[1].accountNumber)
          this.limitTwo = this.decryptResponse(res2.data)
          const res3 = await this.getAvailableLimit(this.userAccounts[2].accountNumber)
          this.limitThree = this.decryptResponse(res3.data)
          const res4 = await this.getAvailableLimit(this.userAccounts[3].accountNumber)
          this.limitFour = this.decryptResponse(res4.data)
        }
      }).catch(error => {
        const decryptedError = decrypt(error.response.data);
        const objError = JSON.parse(decryptedError);
        this.$swal({
          title: 'Oops...',
          text: objError.errors[0],
          type: 'error',
          confirmButtonText: 'Ok'
        });
      });
      this.getDateDetails();
    },
    methods : {
      onCopyCode () {
        this.isCopycode = true;
      },
      async getAvailableLimit(accountNumber) {
        try {
          const response = await this.$store.dispatch('transfers/getAvailableTransactionLimit', accountNumber);
          return response
        } catch (error) {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          }); 
        }
      },
      decryptResponse (data) {
        const decryptedData = decrypt(data);
        const userParseData = JSON.parse(decryptedData);
        return userParseData
      },
      getDateDetails() {
        var d = new Date();
        var curHr = this.addZero(d.getHours());
        var curMi = this.addZero(d.getMinutes());
        var meridiem = curHr >= 12 ? 'PM' : 'AM';
        this.time = curHr + ':' + curMi + ' ' + meridiem;
        if (curHr < 12) {
          this.greeting = 'Good Morning';
        }else if (curHr < 18) {
          this.greeting = 'Good Afternoon';      
        }else {
          this.greeting = 'Good Evening';
        }
      },
      addZero(i) {
        if (i < 10) {
          i = '0' + i;
        }
        return i;
      },
      fecthData() {
        const data = {
          accountNumber: this.userAccountNumber,
          startDate: moment().startOf('week').format('YYYY-MM-DD'),
          endDate: moment().endOf('week').format('YYYY-MM-DD')
        };
        this.loaded = false;
        this.loader = true;
        this.$store.dispatch('dashboard/getInflowOutflowData', { data }).then((response) => {
          this.loaded = true;
          this.loader = false;
          const cummulativeInflow = [];
          const cummulativeOutflow = [];
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          userParseData.forEach(element => {
            cummulativeInflow.push(element.cummulativeInflow);
            cummulativeOutflow.push(element.cummulativeOutflow);
            this.chartData.datasets[0].data = cummulativeInflow;
            this.chartData.datasets[1].data = cummulativeOutflow;
          });
        });
      },
      selectWeek(event) {
        this.chartData.datasets[0].data = [];
        this.chartData.datasets[1].data = [];
        const week = event.target.value;
        if(week === 'lastWeek') {
          const data = {
            accountNumber: this.accountNumber,
            startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          };
          this.loaded = false;
          this.loader = true;
          this.$store.dispatch('dashboard/getInflowOutflowData', { data }).then((response) => {
            this.loaded = true;
            this.loader = false;
            const cummulativeInflow = [];
            const cummulativeOutflow = [];
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            userParseData.forEach(element => {
              cummulativeInflow.push(element.cummulativeInflow);
              cummulativeOutflow.push(element.cummulativeOutflow);
              this.chartData.datasets[0].data = cummulativeInflow;
              this.chartData.datasets[1].data = cummulativeOutflow;
            });
          });
        } else if (week === 'thisWeek') {
          this.fecthData();
        }
      },
      fetchTransactionVolume() {
        const data = {
          accountNumber: this.userAccountNumber,
          startDate: moment().startOf('week').format('YYYY-MM-DD'),
          endDate: moment().endOf('week').format('YYYY-MM-DD')
        };
        this.newloaded = false;
        this.newloader = true;
        this.$store.dispatch('dashboard/getTransactionVolume', { data }).then((response) => {
          this.newloaded = true;
          this.newloader = false;
          if(response.status === 200) {
            // const data = response.data;
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            userParseData.forEach(element => {
              const value = [element.totalAirtimeRechargeVolume, element.totalBillsPaymentVolume, element.totalInterBankTransferVolume, element.totalLocalTransferVolume];
              this.data.datasets[0].data = value;
            });
          }
        });
      },
      selectVolumeWeek(event) {
        this.data.datasets[0].data = [];
        const week = event.target.value;
        if(week === 'lastWeek') {
          const data = {
            accountNumber: this.volumeAccountNumber,
            startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          };
          this.newloaded = false;
          this.newloader = true;
          this.$store.dispatch('dashboard/getTransactionVolume', { data }).then((response) => {
            this.newloaded = true;
            this.newloader = false;
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            userParseData.forEach(element => {
              const value = [element.totalAirtimeRechargeVolume, element.totalBillsPaymentVolume, element.totalInterBankTransferVolume, element.totalLocalTransferVolume];
              this.data.datasets[0].data = value;
            });
          });
        } else if (week === 'thisWeek') {
          this.fetchTransactionVolume();
        }
      },
    },
  };
</script>
<style scoped>
.badge-custom {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #e41f13;
  background: #e41f1310;
  opacity: 1;
}
.form-control {
  font-size: 12px;
  font-weight: 400;
  color: #000 !important;
  padding: 0.375rem 0.6rem;
}
.loader-box .loader-15 {
  background: #e41f13 !important;
}
/**====== custom scrollbar css start ======**/
.custom-scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #ecf3fa;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(68, 102, 242, 0.15);
}

/**====== Custom scrollbar css end ======**/
/**====== Animation css Start ======**/
.comment {
  color: #9f9ba5;
  font-style: italic;
}

.line {
  color: #2c323f;
}
.line pre {
  font-size: 100%;
}

/**====== Animation css end ======**/
/**====== list style css Start ======**/
.list-circle {
  list-style: circle;
}

/**====== list style css end ======**/
/**====== Modal style css Start ======**/
.theme-close {
  opacity: 1;
  height: 40px;
  width: 40px;
  position: absolute;
  font-weight: 400;
  z-index: 1;
  right: 0;
  background-color: #fff !important;
  border-radius: 5px;
}

/**====== Modal style css end ======**/
/**====== Animation css start ======**/
.options > div {
  color: #cccccc;
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid;
  margin: 0 8px 8px 0;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.options > div:hover {
  background-color: #7366ff;
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

/**====== Animation css Ends ======**/
.modal-footer {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.img-cropper #putData {
  margin-bottom: 0;
}

.img-cropper .img-container {
  min-height: auto;
  margin-bottom: 0;
}

.img-cropper .docs-data > .input-group:last-child {
  margin-bottom: 0;
}

.img-cropper .docs-preview {
  margin-top: 20px;
  margin-bottom: 10px;
}

.dropzone .dz-preview .dz-error-message {
  background: #fff !important;
  color: #7366ff !important;
  border: 1px solid #7366ff;
}
.dropzone .dz-preview .dz-error-message:after {
  border-bottom: 6px solid #7366ff !important;
}

.typeahead .theme-form .form-group {
  margin-bottom: 0;
}

.editor-statusbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.page-builder .ge-canvas.ge-editing .row {
  padding: 30px;
  margin-bottom: 0;
  background-color: rgba(228, 31, 19, 0.02);
}

.page-builder .btn-screen {
  padding: 0 18px 0 0;
}

.bg-overlay.active {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 8;
  top: 0;
}

button:focus {
  outline: none !important;
}

.dotted {
  border-style: dotted;
}

.dashed {
  border-style: dashed;
}

.double {
  border-style: double;
}

.groove {
  border-style: groove;
}

.ridge {
  border-style: ridge;
}

.inset {
  border-style: inset;
}

.outset {
  border-style: outset;
}

@-webkit-keyframes fadeIncustom {
  0% {
    opacity: 0;
    top: 50px;
  }
  75% {
    opacity: 0.6;
    top: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeIncustom {
  0% {
    opacity: 0;
    top: 50px;
  }
  75% {
    opacity: 0.6;
    top: 0;
  }
  100% {
    opacity: 1;
  }
}

/**=====================
     Reset css Ends
==========================**/

.loader-box .loader-5 {
  border: 0.2em solid transparent;
  border-top-color: #f8d62b;
  border-radius: 50%;
  -webkit-animation: 1s loader-05 linear infinite;
  animation: 1s loader-05 linear infinite;
  position: relative;
}
.loader-box .loader-5:before {
  content: "";
  display: block;
  width: inherit;
  height: inherit;
  position: absolute;
  top: -0.2em;
  left: -0.2em;
  border: 0.2em solid #f8d62b;
  border-radius: 50%;
  opacity: 0.5;
}

@-webkit-keyframes loader-05 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loader-05 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/** card **/
.profile-greeting {
  max-height: 90%;
  background-image: url(../../assets/TAJimages/dashboard/redbg.png);
  background-size: cover !important;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  box-shadow:0 25px 45px rgb(0 0 0 / 20%);
  backdrop-filter:blur(5px);
  /*background:rgba(255,255,255, 0.1);*/
}
.profile-greeting .card-body {
  /* padding: 36px 20px; */
}
.profile-greeting .badge-groups .badge.f-12 svg {
  width: 16px;
  height: 16px;
}
.profile-greeting .media .media-body p {
  font-weight: 500;
  font-size: 10px;
}
.profile-greeting .media .badge-groups {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-left: -17px;
}
.profile-greeting .media .badge-groups .badge {
    color: #ffffff !important;
    padding: 10px 14px !important;
}
.profile-greeting .media .badge-groups .badge:first-child {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 5px;
}
.profile-greeting .media .badge-groups .badge:last-child {
  border-radius: 5px;
  text-align: left;
}
.profile-greeting .greeting-user {
  margin: 1% 0;
}
    .profile-greeting .greeting-user h4 {
        margin-top: 30px;
        margin-bottom: 20px;
        color: #ffffff;
        font-family: 'Open Sans';
    }
.profile-greeting .greeting-user p {
  font-weight: 500;
  margin-bottom: 25px;
}
    .profile-greeting .greeting-user p span {
        color: #ffffff !important;
    }
.profile-greeting .greeting-user .profile-vector {
  -webkit-filter: drop-shadow(15px 17px 12px rgba(0, 0, 0, 0.1));
  filter: drop-shadow(15px 17px 12px rgba(0, 0, 0, 0.1));
}
.profile-greeting .greeting-user .right-circle i {
  padding: 5px 6px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
}
.profile-greeting .greeting-user .left-icon {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 20px 20px 20px 10px;
  position: absolute;
  left: 4%;
  bottom: 4%;
}
.profile-greeting .greeting-user .left-icon i {
  color: #fff;
  margin-top: 38%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  -webkit-animation: tada 1.5s ease infinite;
  animation: tada 1.5s ease infinite;
}
.profile-greeting .whatsnew-btn .btn {
    background-color: #ffffff !important;
    border-radius: 5px;
    color: #2B2B2B;
    font-weight: 500;
    padding: 6px 18px;
    font-family: 'Open Sans';
    letter-spacing: 0px;
    font-weight: 400;
}
  .profile-greeting .whatsnew-btn .btn:hover {
    background-color: #e41f13 !important;
    border-radius: 5px;
    color: #fff;
    font-weight: 500;
    padding: 6px 18px;
    font-family: 'Open Sans';
    letter-spacing: 0px;
  }
/**=====================
Custom Styles
========================**/
.acct-details {
/*background: #f7f7f7;*/
border-radius: 10px;
margin: 10px;
margin-top: 12px !important;
padding: 10px 10px 0px 10px;
}
.acct-details .acct-name{
font-size:10px;
}
.acct-details .acct-num {
    margin-bottom: 10px;
    font-family: Open Sans;
    /*text-transform: capitalize;*/
}

.acct-details .acct-count{
  font-size:8px;
  padding:5px;
  border-radius:5px;
  background:#efefef
}

.acct-details .acct-type{
  font-size:10px;
  padding:7px;
  background: rgba(228, 31, 19, 0.08);
  border-radius:10px;
  margin-bottom:20px
}

.acct-led-bal{
  font-size:12px
}
/* my custom css */
.form-select {
  display: block;
  width: 100%;
  padding: 8px 12px;
  /* font-size: 1rem; */
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.accountCard {
  background-image: url(../../assets/TAJimages/dashboard/balanceCard.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.icon-wrapper {
  margin: 0 auto;
  padding: 25px;
  background: #fff;
  height: 35px;
  width: 35px;
  border-radius: 50%;
}
div >>> .icon-feather {
  position: relative;
  bottom: 10px;
  right: 12px;
}
.text-icon {
  margin-top: 5px;
  color: #2B2B2B;
  font-weight: 400;
  margin-bottom: 0px;
}
.card-wrapper {
  padding: 20px !important;
}
.card-wrapper:hover {
  box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -webkit-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -moz-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
}
.account-balance {
  font-size: 21px;
}
.fund-transfer {
  background: #fff0e4;
}
.pay-bills {
  background: #e4ffec;
}
.airtime-data {
  background: #F2F2FF;
}
.quick-balance {
  background: #FFF1E0;
}
.lifestyle-text {
  position: absolute;
  bottom: 10px;
  left: 40px;
  font-size: 21px;
  font-weight: 300;
  color: #fff;
}
.lifestyle-card img {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  height: 215px;
  border-radius: 15px;
}
.lifestyle-card img:hover {
  box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -webkit-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -moz-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
}
.lifestyle-card-wrapper {
  border: 1px solid #e41f13;
}
.card .card-header {
  background: #FFEFED;
  padding: 30px;
}
@media screen and (max-width: 768px) {
  .lifestyle-card img {
    height: 100%;
    margin-top: 10px;
  }
  .lifestyle-card {
    margin-top: 30px;
  }
  .fit-mobile {
    justify-content: center !important;
    text-align: center;
    margin-top: 15px !important;
  }
}
</style>